export const DEFAULT_PAGE = 1;
export const DEFAULT_PER_PAGE = 10;

export const DEFAULT_LOCALE = "ja";

// 開発環境ではVercelがないのでX-Forwarded-Forヘッダーは常にundefinedになる
// 固定のIPアドレスを使用することで開発環境でも動作確認ができる
export const LOCAL_STATIC_IP = "153.246.214.177";
